import { render } from "./DrawerPanel.vue?vue&type=template&id=6de5af4f&scoped=true"
import script from "./DrawerPanel.vue?vue&type=script&lang=js"
export * from "./DrawerPanel.vue?vue&type=script&lang=js"

import "./DrawerPanel.vue?vue&type=style&index=0&id=6de5af4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de5af4f"]])

export default __exports__